import { gql } from '@apollo/client'

export default gql`
  fragment Report on ReportDTO {
    id
    filename
    format
    type
    companyName
    country
    size
    date
    downloadLink
    status
    creator {
      id
      firstName
      lastName
    }
    createTargetReport
  }
`
